module.exports = __webpack_public_path__ + "static/conectaOLXBG-e9bcd805e66e80c51cd12afd571d6bb0.jpg";